import css from '../tpl-css/style-section-banner-kynorelle.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="false"
  data-bottom-padding="false"
  style="background-color: #ffffff;"
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="false"
    data-background="#FFFFFF"
    style="background-color: transparent;"
  >
    <div data-attribute="container" class="">
      <div class="wrap-card">
        <div class="swiper banner-kynorelle-slider mySwiperBannerKynorelle-unique-id">
          <div data-attribute="list-item" class="swiper-wrapper">
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item-slide">
                <div class="container-content-item">
                  <div class="container">
                    <div class="wrap-content">
                      <div data-show="true" data-attribute="block-subtitle" class="block-subtitle">
                        <div class="wrap-icon">
                          <img
                            data-attribute="subtitle-icon"
                            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e82b22b83feca170e484.png"
                            alt=""
                          />
                        </div>
                        <div data-attribute="text-subtitle" class="text-subtitle">trusted by over 57,481+ Customer</div>
                        <div class="wrap-avatars">
                          <img
                            data-attribute="subtitle-avatars"
                            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e82f68413cba338ca97c.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div data-show="true" data-attribute="title-banner-item" class="title-banner-item">
                        <h2>
                          <span style="color:#003566;">NOT ONLY MORE BEAUTIFUL</span><br /><span style="color:#003566;"
                            >BUT ALSO MORE COMFORTABLE</span
                          >
                        </h2>
                        <p><span style="color:#424242;">Wear it once You'll feel the difference</span></p>
                      </div>
                      <div class="image-item-mb">
                        <img
                          data-attribute="image-item-banner-mobile"
                          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e715c1f3b5fa8853d853.png"
                          alt=""
                        />
                      </div>
                      <a
                        data-attribute="button-link-item"
                        data-show="true"
                        class="btn-banner-item"
                        href="#"
                        data-background="#003568"
                        data-color="#FFFFFF"
                        style="--button-background-color: #003568; --button-text-color: #ffffff;"
                      >
                        <span>SHOP NOW</span>
                        <span class="icon">
                          <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L3.2175 4.3875L0 8.775H2.145L5.3625 4.3875L2.145 0H0Z" fill="currentColor" />
                          </svg>
                        </span>
                      </a>
                      <div data-attribute="block-outstanding" data-show="true" class="block-outstanding">
                        <div class="item-otd" data-attribute="outstanding-item">
                          <div data-attribute="text-item-outstanding" class="text-item">
                            <h2>50k+</h2>
                            <p>5 Star Reviews</p>
                          </div>
                        </div>
                        <div class="item-otd" data-attribute="outstanding-item">
                          <div data-attribute="text-item-outstanding" class="text-item">
                            <h2>Nearly 50k</h2>
                            <p>Trusted Customers</p>
                          </div>
                        </div>
                        <div class="item-otd" data-attribute="outstanding-item">
                          <div data-attribute="text-item-outstanding" class="text-item">
                            <h2>30-Day</h2>
                            <p>Guarantee</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-attribute="image-item-banner" class="image-item">
                  <img
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e711e9507b7c104d056f.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
